<div class="card right">
  <div class="ui-g form-group">
    <div class="ui-g-12">
      <h1 class="campaign-step">{{ 'campaign.chooseStores' | translate}}</h1>
    </div>
    <div class="ui-g-6">
      <button pButton data-testid="add_stores" type="button" class="SaveExit" label="{{'campaign.add_stores' | translate}}" (click)="togglePopupStores()"></button>
    </div>
    <div class="ui-g-6">
      <button pButton data-testid="add_group" type="button" class="SaveExit grey" label="{{'campaign.addSavedGroup' | translate}}" (click)="togglePopupGroups()"></button>
    </div>
    <div class="ui-g-12 testadd" *ngIf="this.campaign.stores.length > 0">
      {{ this.campaign.stores.length }} {{'campaign.storesAdded'}}
    </div>
    <div class="ui-g-12 list-campaign">
      <div class="ui-g-12 list" *ngFor="let store of this.campaign.stores">
        <div class="ui-g-2">
          <div class="number">{{ store.host_code }}</div>
        </div>
        <div class="ui-g-9">
          <div class="user-name">
            {{ store.name }}
          </div>
          <div class="address">
            {{ store.region }}, {{ store.city }}, {{ store.address }}
          </div>
        </div>
        <div class="ui-g-1">
          <a class="fa fa-trash red" (click)="deleteStore(store.id)" aria-hidden="true"></a>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- **** ADD STORE POPUP **** -->
<p-dialog styleClass="dialog1" header="{{'campaign.add_stores' | translate}}" [(visible)]="popupStores" modal="modal" showEffect="fade" [responsive]="true" [draggable]="false">

  <div class="ui-fluid ui-g-12 filter">

    <div class="ui-g-2">{{ 'campaign.filteredBy' | translate }}</div>
    <div class="ui-g-10 ui-g-nopad">
      <div class="ui-g-4">
        <p-multiSelect  class="store-filter-multiselect" defaultLabel="{{ 'campaign.areas' | translate }}" [style]="{ width: '100%' }" [options]="regionNames" [(ngModel)]="filter.area"></p-multiSelect>
      </div>
      <div class="ui-g-4">
        <p-multiSelect class="store-filter-multiselect" defaultLabel="{{ 'campaign.sign' | translate }}" [style]="{ width: '100%' }" [filter]="true" [options]="insegne" [(ngModel)]="filter.insegna"></p-multiSelect >
      </div>
      <div class="ui-g-4">
        <p-dropdown [style]="{ width: '100%' }" [filter]="true" [options]="groupNames" [(ngModel)]="filter.gruppo"></p-dropdown>
      </div>
    </div>

    <div class="ui-g-12">
      <div class="ui-g-4"></div>
      <div class="add ui-g-2">
        <button pButton type="button" class="reset" label="Reset" (click)="initFilter()"></button>
      </div>
      <div class="add ui-g-2">
        <button pButton type="button" class="apply" label="{{ 'common.apply' | translate }}" (click)="confirm()"></button>
      </div>
      <div class="ui-g-4"></div>
    </div>
  </div>

  <div class="ui-dialog-inner">
    <div class="ui-g-12">
      <div class="saved">{{stores.length}} {{ 'campaign.storesFound' | translate }}</div>
    </div>
    <div class="ui-g-12">
      <hr style="border-top:0px; border-color:#dde3e6">
    </div>

    <div class="ui-g-2">
      <div class="sel" (click)="selectAll()">{{ 'common.selectAll' | translate }}</div>
    </div>

    <div class="ui-g-2">
      <div class="unsel" (click)="unselectAll()">{{ 'common.unselectAll' | translate }}</div>
    </div>

    <div class="ui-g-4 butright" *ngIf="!saveAsGroup">
      <button pButton type="button" class="AddSelectedGroup" label="{{ 'campaign.saveAsGroup' | translate }}" (click)="inputGroupName(true)"></button>
    </div>

    <div class="ui-g-4 saveAsGroup" *ngIf="saveAsGroup">
      <div class="ui-g-8 ui-g-nopad">
        <input type="text" pInputText placeholder="Inserisci nome gruppo" [(ngModel)]="newGroupName" />
      </div>
      <div class="ui-g-2 ui-g-nopad">
        <button pButton type="button" class="nosuccess" icon="fa fa-times" (click)="inputGroupName(false)"></button>
      </div>
      <div class="ui-g-2 ui-g-nopad">
        <button pButton type="button" class="success" icon="fa fa-check" (click)="saveGroup()"></button>
      </div>
    </div>

    <div class="ui-g-4 butright">
      <button pButton type="button" data-testid="AddSelected" class="AddSelected" label="{{ 'common.add' | translate }}" (click)="addStores()"></button>
    </div>

    <div class="ui-g-12">
      <p-dataTable [value]="stores" class="store-table">
        <p-column styleClass="col-button">
          <ng-template let-col let-store="rowData" pTemplate="body">
            <p-checkbox name="selectedStoresId" value="{{ store.id }}" [(ngModel)]="selectedStoresId"></p-checkbox>
          </ng-template>
        </p-column>
        <p-column field="host_code" header="{{ 'common.storeCode' | translate }}"></p-column>
        <p-column field="name" header="{{ 'common.storeName' | translate }}"></p-column>
        <p-column field="classificationDetailCode" header="{{ 'campaign.areas' | translate }}"></p-column>
        <p-column field="city" header="{{ 'common.city' | translate }}"></p-column>
        <p-column field="address_1" header="{{ 'common.address' | translate }}"></p-column>
      </p-dataTable>
    </div>

  </div>
</p-dialog>


<!-- **** ADD GROUP POPUP **** -->
<p-dialog styleClass="dialog1" header="{{'campaign.add_stores' | translate}}" [(visible)]="popupGroups" modal="modal" showEffect="fade" [responsive]="true" [draggable]="false" [modal]="true">

  <div class="ui-g-12 filter">
    <div class="topbar-search">
      <input #groupSearch data-testid="groupSearch" type="text" placeholder="{{ 'campaign.searchSavedGroup' | translate }}" (keyup)="0"/>
      <div class="topbar-search-icon fa fa-search"></div>
    </div>
  </div>

  <div class="ui-dialog-inner">
    <div class="ui-g-12">
      <div class="saved">{{ groups.length }} {{ 'campaign.savedGroups' | translate }}</div>
    </div>

    <div class="ui-g-12">
      <hr style="border-top:0px; border-color:#dde3e6">
    </div>

    <div class="ui-g-4"></div>
    <div class="ui-g-4 butright">
      <button pButton type="button" class="AddSelected" label="{{ 'common.add' | translate }}" (click)="addStoresFromGroups()"></button>
    </div>

    <div class="ui-g-12">
      <p-dataTable [value]="groups" [globalFilter]="groupSearch" class="store-table">
        <p-column styleClass="col-button">
          <ng-template let-col let-group="rowData" pTemplate="body">
            <p-radioButton name="selectedGroupsId" value={{group.id}} [(ngModel)]="selectedGroupsId"></p-radioButton>
          </ng-template>
        </p-column>
        <p-column field="id" hidden="true"></p-column>
        <p-column field="name" header="{{ 'common.storeGroupName' | translate }}"></p-column>
        <p-column field="stores_host_code" header="{{ 'campaign.storeCodes' | translate }}"></p-column>
      </p-dataTable>
    </div>

  </div>
</p-dialog>

<p-confirmDialog key="confirm"></p-confirmDialog>



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-4/stores/campaign-stores.html